import React from 'react';
import { Modal, Text, Layout, Divider, Row, Button } from '@dls/web';
import {IContentReviewer} from './models/ContentReviewerModel';
import * as SC from './styles';
import useTranslation from '@/hooks/useTranslation';

const ContentReviewer = ({ data, title, onClose, visible }:IContentReviewer) => {
  const { t } = useTranslation();

  return (
    <Modal
      visible={visible}
      title={title}
      onClose={onClose}
      bgColor="haze"
      wide
      data-testid="tandc-modal"
    >
      <Modal.Content>
        <SC.ModalContainer>
        <Layout.Stack>
          <Text type="smallBody">
            <span
              dangerouslySetInnerHTML={{
                __html: data || ''
              }}
            />
          </Text>
          <Divider />
          <Row center="xs">
            <Button data-testid="tandc-close-button" onClick={onClose}>
              {t('ACTION_BUTTON_OK')}
            </Button>
          </Row>
        </Layout.Stack>
        </SC.ModalContainer>
      </Modal.Content>
    </Modal>
  );
};
export default ContentReviewer;
